import analyticDataStore, {
  IBaseAnalyticsCombined,
} from "@/store/analyticsDataStore";
import { useTheme } from "next-themes";
import { useEffect, useState } from "react";
import DateRangeAndSlider from "../ClientSummaryReport/DateRangeAndSlider";
import MultiFilterSankey from "./MultiFilterSankey";
import SankeyFlowChart from "./SankeyFlowChart";

export interface SankeyDataFilter {
  range: number[];
  selectedCurrencies: string[];
  selectedInstruments: string[];
  selectedStructure: string[];
  selectedBuckets: string[];
  selectedIssueCountry: string[];
  selectedStrategy: string[];
  selectedCustomers: string[];
}

const IndexFlowAnalysis = () => {
  const analyticsZustand = analyticDataStore((state) => state.analyticData);

  const [data, setData] = useState<IBaseAnalyticsCombined[]>(analyticsZustand);

  useEffect(() => {
    setData(analyticsZustand);
  }, [analyticsZustand]);

  const [dataFilters, setDataFilters] = useState<SankeyDataFilter>({
    range: [],
    selectedCurrencies: [],
    selectedInstruments: [],
    selectedStructure: [],
    selectedBuckets: [],
    selectedIssueCountry: [],
    selectedStrategy: [],
    selectedCustomers: [],
  });
  const { theme } = useTheme();

  return (
    <div className="w-fill h-full p-1">
      <div className="flex h-full w-full gap-3">
        <div className="flex h-full min-w-[230px] flex-col gap-3">
          {/* TOP SQUARE */}
          <div
            className={`${theme == "dark" ? "agChartCubeBorderDark" : "agChartCubeBorder"} h-full w-full p-2`}
          >
            <div className="flex h-full w-full ">
              <div id="sideContainer" className="flex h-full w-full flex-col ">
                <DateRangeAndSlider
                  dataFilters={dataFilters}
                  setDataFilters={setDataFilters}
                  isSecondary={false}
                />

                {/* Filter toggles */}
                <MultiFilterSankey
                  data={data}
                  dataFilters={dataFilters}
                  setDataFilters={setDataFilters}
                />
              </div>
            </div>
          </div>
        </div>
        {/* Responsive section of widget frame - will expand and contract as requierd. */}
        {/* Main chart */}
        <div className="flex h-full w-full">
          <SankeyFlowChart
            data={data}
            dataFilters={dataFilters}
            setDataFilters={setDataFilters}
          />
        </div>
      </div>
    </div>
  );
};

export default IndexFlowAnalysis;
